import React from 'react';
import styled from 'styled-components';
import { Button, Tooltip, Typography } from 'antd';
import {
  PiSquaresFourBold,
  PiListBulletsBold,
  PiNotePencilBold,
  PiPlusBold,
} from 'react-icons/pi';

const { Text } = Typography;

interface CollectFormTemplateHeaderProps {
  viewMode: 'grid' | 'list';
  totalCount: number;
  onViewModeChange: (mode: 'grid' | 'list') => void;
  onDesignNew: () => void;
}

export const CollectFormTemplateHeader: React.FC<CollectFormTemplateHeaderProps> = ({
  viewMode,
  totalCount,
  onViewModeChange,
  onDesignNew,
}) => {
  return (
    <UI_HeaderWrapper>
      <UI_LeftSection>
        <UI_Title>
          <PiNotePencilBold className="title-icon" />
          <span>Template biểu mẫu</span>
          <UI_BadgeCount>({totalCount} template)</UI_BadgeCount>
        </UI_Title>
      </UI_LeftSection>

      <UI_RightSection>
        <UI_ViewToggle>
          <Tooltip title="Chế độ lưới">
            <UI_IconButton
              type={viewMode === 'grid' ? 'primary' : 'text'}
              icon={<PiSquaresFourBold size={16} />}
              onClick={() => onViewModeChange('grid')}
            />
          </Tooltip>
          <Tooltip title="Chế độ danh sách">
            <UI_IconButton
              type={viewMode === 'list' ? 'primary' : 'text'}
              icon={<PiListBulletsBold size={16} />}
              onClick={() => onViewModeChange('list')}
            />
          </Tooltip>
        </UI_ViewToggle>

        <Button
          type="primary"
          icon={<PiPlusBold size={14} />}
          onClick={onDesignNew}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            borderRadius: '6px',
            fontWeight: 500,
          }}
        >
          Thiết kế biểu mẫu
        </Button>
      </UI_RightSection>
    </UI_HeaderWrapper>
  );
};

const UI_HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  gap: 12px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const UI_LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const UI_Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;

  .title-icon {
    font-size: 20px;
    color: #2563eb;
  }
`;

const UI_BadgeCount = styled(Text)`
  font-size: 13px;
  font-weight: normal;
  color: #64748b;
`;

const UI_RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 640px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const UI_ViewToggle = styled.div`
  display: flex;
  align-items: center;
  background-color: #f1f5f9;
  border-radius: 6px;
  padding: 2px;
  gap: 2px;
`;

const UI_IconButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px !important;
  border: none !important;

  &:not(.ant-btn-primary) {
    color: #64748b;
    background: transparent;

    &:hover {
      color: #1e293b;
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;
